interface IScripts {
    name: string;
    src: string;
}
export const ScriptStore: Array<IScripts> = [];
